/*
* Copyright (C) Regione Lombardia
*/
export interface DialogMessage {
    message: string;
    level: DialogMessageLevel;
    codice?: string;
    icon?: string;
    title?: string;
    iconClassName?: string;
    className?: string;
}
export enum DialogMessageLevel {
    INFO = 'INFO',
    WARNING = 'WARNING',
    ERROR = 'ERROR',
    SUCCESS = 'SUCCESS',
    DISABLED = 'DISABLED',
}
